import axios from 'axios';
import { CustomerAssortment } from 'views/profiles-strategies/features/feed-strategies/types/customer-assortment.type';

// GET
// /ewosapi/v1/products/customerassortment/{customerNumber}
// Returns customer products for creating feed strategies.
export const getProductsCustomerAssortment = async (customerNumber: string): Promise<CustomerAssortment[]> => {
  const res = await axios.get<CustomerAssortment[]>(`/ewosapi/v1/products/customerassortment/${customerNumber}`);
  return res.data;
};

// GET
// /ewosapi/v1/products/articles
// Returns all products for market filtering our special articles.
export const getProductsArticles = async (): Promise<CustomerAssortment[]> => {
  const res = await axios.get<CustomerAssortment[]>(`/ewosapi/v1/products/articles`);
  return res.data;
};

// GET
// /ewosapi/v1/products/marketspecialarticles/{market}
// export const getProductsMarketSpecialArticles = async (market: number): Promise<[]> => {
//   const res = await axios.get<[]>(`/ewosapi/v1/products/marketspecialarticles/${market}`);
//   return res.data;
// };
